// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymasterModal_title__1ppkA"};